import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=0187d3b4&"
import script from "./BaseList.vue?vue&type=script&lang=js&"
export * from "./BaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports